/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { transactionControllerTotalOfCurrentPeriod } from '../fn/transaction/transaction-controller-total-of-current-period';
import { TransactionControllerTotalOfCurrentPeriod$Params } from '../fn/transaction/transaction-controller-total-of-current-period';
import { transactionControllerTotalOfPreviousPeriod } from '../fn/transaction/transaction-controller-total-of-previous-period';
import { TransactionControllerTotalOfPreviousPeriod$Params } from '../fn/transaction/transaction-controller-total-of-previous-period';

@Injectable({ providedIn: 'root' })
export class TransactionApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `transactionControllerTotalOfCurrentPeriod()` */
  static readonly TransactionControllerTotalOfCurrentPeriodPath = '/api/transaction/total-of-current-period';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transactionControllerTotalOfCurrentPeriod()` instead.
   *
   * This method doesn't expect any request body.
   */
  transactionControllerTotalOfCurrentPeriod$Response(params?: TransactionControllerTotalOfCurrentPeriod$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<number>>> {
    const obs = transactionControllerTotalOfCurrentPeriod(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `transactionControllerTotalOfCurrentPeriod$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  transactionControllerTotalOfCurrentPeriod(params?: TransactionControllerTotalOfCurrentPeriod$Params, context?: HttpContext): Observable<Array<number>> {
    const resp = this.transactionControllerTotalOfCurrentPeriod$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<number>>): Array<number> => r.body)
    );
  }

  /** Path part for operation `transactionControllerTotalOfPreviousPeriod()` */
  static readonly TransactionControllerTotalOfPreviousPeriodPath = '/api/transaction/total-of-previous-period';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transactionControllerTotalOfPreviousPeriod()` instead.
   *
   * This method doesn't expect any request body.
   */
  transactionControllerTotalOfPreviousPeriod$Response(params?: TransactionControllerTotalOfPreviousPeriod$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<number>>> {
    const obs = transactionControllerTotalOfPreviousPeriod(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `transactionControllerTotalOfPreviousPeriod$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  transactionControllerTotalOfPreviousPeriod(params?: TransactionControllerTotalOfPreviousPeriod$Params, context?: HttpContext): Observable<Array<number>> {
    const resp = this.transactionControllerTotalOfPreviousPeriod$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<number>>): Array<number> => r.body)
    );
  }

}
